export const learnSortConstants = {
    sortSelected: "SORT_SELECTED",
    isProgressRateOrder: "IS_PROGRESS_RATE_ORDER",

    order: "order",

    registrationDate: "REGISTRATION_DATE",
    courseTitle: "COURSE_TITLE",
    registrant: "REGISTRANT",
    progressRate: "PROGRESS_RATE",
    learningEndDate: "LEARNING_END_DATE",
    likes: "LIKES",
    
    desc: "DESC"
}